/**
 * Regio-geometrie (lon/lat, WGS84) voor de radar-basiskaart, náást `nl-geometry.ts`:
 * buurland-vlakken (BE/DE/FR/LU, geclipt op de uitsnede), hun kustlijnen als losse
 * polylijnen (zodat de cliprand zelf nooit als "kust" gestroked wordt), de
 * NL-provinciegrenzen en de grote rivieren (Rijn/Waal/Maas/IJssel/Lek/Schelde/Vecht e.a.).
 *
 * bron: Natural Earth 10m (public domain) — `ne_10m_admin_0_countries`,
 * `ne_10m_admin_1_states_provinces_lines`, `ne_10m_rivers_lake_centerlines` +
 * `ne_10m_rivers_europe`; geclipt op de NL_VIEW-uitsnede (+0,05 graden marge) en
 * afgerond op 3 decimalen. Puur weergavedata; geen runtime-call, geen map-bibliotheek (§2).
 */

import type { GeoRing } from './nl-geometry.js';

/** Buurland-vlakken (gevuld, vergrijsd) — geclipte ringen, alleen voor fill. */
export const NEIGHBOR_LAND: ReadonlyArray<GeoRing> = [
  [
    [2.66, 50.6],
    [2.66, 50.813],
    [2.669, 50.814],
    [2.679, 50.813],
    [2.692, 50.809],
    [2.697, 50.803],
    [2.7, 50.796],
    [2.707, 50.789],
    [2.744, 50.766],
    [2.75, 50.76],
    [2.763, 50.739],
    [2.768, 50.733],
    [2.787, 50.723],
    [2.867, 50.7],
    [2.871, 50.699],
    [2.887, 50.697],
    [2.9, 50.703],
    [2.93, 50.736],
    [2.948, 50.749],
    [2.971, 50.758],
    [3.024, 50.768],
    [3.103, 50.784],
    [3.129, 50.779],
    [3.146, 50.769],
    [3.163, 50.75],
    [3.177, 50.734],
    [3.189, 50.715],
    [3.197, 50.709],
    [3.211, 50.708],
    [3.224, 50.705],
    [3.232, 50.696],
    [3.244, 50.672],
    [3.23, 50.655],
    [3.238, 50.626],
    [3.25, 50.6],
  ],
  [
    [7.91, 53.71],
    [7.91, 50.6],
    [6.245, 50.6],
    [6.251, 50.608],
    [6.249, 50.614],
    [6.18, 50.616],
    [6.159, 50.622],
    [6.148, 50.637],
    [6.161, 50.642],
    [6.1, 50.701],
    [6.081, 50.713],
    [6.064, 50.714],
    [6.025, 50.708],
    [6.012, 50.709],
    [6.008, 50.717],
    [6.011, 50.727],
    [6.011, 50.737],
    [5.994, 50.743],
    [5.993, 50.744],
    [5.993, 50.746],
    [5.993, 50.748],
    [5.995, 50.75],
    [5.997, 50.763],
    [5.991, 50.769],
    [5.981, 50.773],
    [5.973, 50.782],
    [5.969, 50.795],
    [5.984, 50.792],
    [5.998, 50.801],
    [6.004, 50.813],
    [6.001, 50.822],
    [6.0, 50.83],
    [6.009, 50.84],
    [6.023, 50.845],
    [6.046, 50.844],
    [6.057, 50.853],
    [6.063, 50.863],
    [6.063, 50.871],
    [6.055, 50.891],
    [6.057, 50.898],
    [6.062, 50.904],
    [6.064, 50.908],
    [6.031, 50.915],
    [6.008, 50.924],
    [6.0, 50.929],
    [5.997, 50.937],
    [5.996, 50.952],
    [6.0, 50.96],
    [6.006, 50.969],
    [6.004, 50.974],
    [5.968, 50.971],
    [5.942, 50.976],
    [5.928, 50.978],
    [5.914, 50.975],
    [5.888, 50.967],
    [5.875, 50.965],
    [5.874, 50.991],
    [5.858, 51.019],
    [5.852, 51.043],
    [5.88, 51.052],
    [5.894, 51.047],
    [5.906, 51.037],
    [5.92, 51.03],
    [5.938, 51.031],
    [5.95, 51.039],
    [5.969, 51.065],
    [5.983, 51.075],
    [6.075, 51.12],
    [6.132, 51.14],
    [6.147, 51.152],
    [6.126, 51.165],
    [6.149, 51.176],
    [6.157, 51.179],
    [6.134, 51.184],
    [6.084, 51.163],
    [6.061, 51.171],
    [6.054, 51.189],
    [6.057, 51.212],
    [6.065, 51.232],
    [6.075, 51.243],
    [6.097, 51.259],
    [6.148, 51.318],
    [6.158, 51.325],
    [6.184, 51.336],
    [6.194, 51.345],
    [6.199, 51.357],
    [6.202, 51.379],
    [6.208, 51.388],
    [6.193, 51.399],
    [6.194, 51.417],
    [6.202, 51.439],
    [6.205, 51.458],
    [6.2, 51.477],
    [6.193, 51.509],
    [6.153, 51.538],
    [6.086, 51.596],
    [6.082, 51.608],
    [6.088, 51.622],
    [6.099, 51.644],
    [6.031, 51.663],
    [6.009, 51.681],
    [6.022, 51.71],
    [6.012, 51.716],
    [5.99, 51.726],
    [5.978, 51.73],
    [5.949, 51.729],
    [5.939, 51.732],
    [5.94, 51.743],
    [5.946, 51.746],
    [5.962, 51.756],
    [5.964, 51.777],
    [5.951, 51.796],
    [5.928, 51.807],
    [5.931, 51.816],
    [5.948, 51.823],
    [5.989, 51.827],
    [6.008, 51.833],
    [6.029, 51.842],
    [6.043, 51.847],
    [6.084, 51.854],
    [6.116, 51.848],
    [6.14, 51.845],
    [6.156, 51.842],
    [6.143, 51.855],
    [6.105, 51.879],
    [6.093, 51.885],
    [6.127, 51.897],
    [6.159, 51.887],
    [6.191, 51.871],
    [6.225, 51.863],
    [6.256, 51.867],
    [6.265, 51.866],
    [6.272, 51.862],
    [6.283, 51.85],
    [6.287, 51.846],
    [6.326, 51.843],
    [6.342, 51.837],
    [6.345, 51.821],
    [6.382, 51.828],
    [6.387, 51.838],
    [6.378, 51.86],
    [6.443, 51.848],
    [6.463, 51.848],
    [6.479, 51.853],
    [6.529, 51.876],
    [6.628, 51.898],
    [6.717, 51.899],
    [6.744, 51.908],
    [6.767, 51.926],
    [6.79, 51.951],
    [6.798, 51.957],
    [6.806, 51.958],
    [6.811, 51.961],
    [6.812, 51.973],
    [6.809, 51.98],
    [6.804, 51.984],
    [6.778, 52.001],
    [6.713, 52.024],
    [6.691, 52.028],
    [6.675, 52.035],
    [6.673, 52.05],
    [6.68, 52.06],
    [6.689, 52.063],
    [6.699, 52.064],
    [6.711, 52.067],
    [6.719, 52.074],
    [6.728, 52.086],
    [6.733, 52.092],
    [6.75, 52.103],
    [6.766, 52.108],
    [6.772, 52.109],
    [6.831, 52.113],
    [6.843, 52.12],
    [6.865, 52.148],
    [6.885, 52.16],
    [6.928, 52.172],
    [6.948, 52.183],
    [6.971, 52.206],
    [6.982, 52.214],
    [7.026, 52.231],
    [7.029, 52.236],
    [7.027, 52.239],
    [7.021, 52.245],
    [7.012, 52.267],
    [7.012, 52.285],
    [7.02, 52.3],
    [7.04, 52.329],
    [7.048, 52.365],
    [7.034, 52.391],
    [6.973, 52.451],
    [6.967, 52.45],
    [6.961, 52.443],
    [6.951, 52.437],
    [6.926, 52.433],
    [6.9, 52.432],
    [6.872, 52.435],
    [6.82, 52.447],
    [6.741, 52.454],
    [6.715, 52.462],
    [6.695, 52.476],
    [6.689, 52.491],
    [6.688, 52.508],
    [6.684, 52.526],
    [6.672, 52.542],
    [6.688, 52.543],
    [6.744, 52.56],
    [6.711, 52.577],
    [6.704, 52.583],
    [6.704, 52.591],
    [6.708, 52.6],
    [6.71, 52.609],
    [6.702, 52.619],
    [6.719, 52.627],
    [6.737, 52.635],
    [6.771, 52.641],
    [6.865, 52.642],
    [6.918, 52.632],
    [6.968, 52.637],
    [6.983, 52.633],
    [7.018, 52.626],
    [7.037, 52.647],
    [7.044, 52.683],
    [7.053, 52.791],
    [7.062, 52.824],
    [7.072, 52.841],
    [7.08, 52.854],
    [7.162, 52.933],
    [7.184, 52.966],
    [7.193, 52.998],
    [7.194, 53.034],
    [7.185, 53.105],
    [7.181, 53.114],
    [7.176, 53.119],
    [7.173, 53.126],
    [7.172, 53.138],
    [7.174, 53.146],
    [7.189, 53.168],
    [7.195, 53.185],
    [7.199, 53.201],
    [7.197, 53.217],
    [7.195, 53.245],
    [7.204, 53.248],
    [7.216, 53.256],
    [7.225, 53.263],
    [7.234, 53.274],
    [7.237, 53.286],
    [7.23, 53.297],
    [7.255, 53.32],
    [7.268, 53.324],
    [7.292, 53.324],
    [7.313, 53.321],
    [7.348, 53.307],
    [7.367, 53.303],
    [7.343, 53.324],
    [7.303, 53.333],
    [7.075, 53.338],
    [7.038, 53.349],
    [7.024, 53.376],
    [7.023, 53.451],
    [7.028, 53.467],
    [7.047, 53.498],
    [7.051, 53.513],
    [7.06, 53.522],
    [7.079, 53.522],
    [7.12, 53.516],
    [7.125, 53.524],
    [7.135, 53.527],
    [7.142, 53.537],
    [7.14, 53.55],
    [7.131, 53.557],
    [7.102, 53.566],
    [7.089, 53.574],
    [7.087, 53.587],
    [7.101, 53.598],
    [7.133, 53.611],
    [7.169, 53.635],
    [7.189, 53.644],
    [7.226, 53.666],
    [7.305, 53.685],
    [7.459, 53.695],
    [7.47, 53.691],
    [7.48, 53.682],
    [7.504, 53.679],
    [7.651, 53.697],
    [7.808, 53.71],
  ],
  [
    [6.798, 53.604],
    [6.776, 53.602],
    [6.741, 53.593],
    [6.722, 53.591],
    [6.722, 53.585],
    [6.734, 53.582],
    [6.742, 53.578],
    [6.75, 53.572],
    [6.757, 53.563],
    [6.748, 53.566],
    [6.735, 53.575],
    [6.726, 53.577],
    [6.716, 53.576],
    [6.701, 53.571],
    [6.695, 53.57],
    [6.677, 53.576],
    [6.663, 53.587],
    [6.66, 53.599],
    [6.671, 53.604],
    [6.747, 53.618],
    [6.785, 53.62],
    [6.798, 53.604],
  ],
  [
    [6.874, 53.673],
    [6.911, 53.684],
    [7.047, 53.694],
    [7.085, 53.687],
    [6.874, 53.673],
  ],
  [
    [7.133, 53.708],
    [7.139, 53.71],
    [7.283, 53.71],
    [7.174, 53.701],
    [7.133, 53.708],
  ],
  [
    [2.66, 51.143],
    [2.716, 51.17],
    [2.924, 51.246],
    [3.125, 51.33],
    [3.349, 51.375],
    [3.358, 51.337],
    [3.354, 51.312],
    [3.353, 51.289],
    [3.367, 51.263],
    [3.392, 51.247],
    [3.399, 51.245],
    [3.422, 51.238],
    [3.454, 51.236],
    [3.501, 51.24],
    [3.504, 51.25],
    [3.502, 51.262],
    [3.503, 51.274],
    [3.514, 51.281],
    [3.529, 51.283],
    [3.545, 51.284],
    [3.585, 51.29],
    [3.61, 51.29],
    [3.635, 51.288],
    [3.757, 51.262],
    [3.776, 51.255],
    [3.781, 51.241],
    [3.78, 51.23],
    [3.781, 51.22],
    [3.796, 51.209],
    [3.809, 51.205],
    [3.927, 51.206],
    [3.949, 51.211],
    [3.995, 51.233],
    [4.119, 51.272],
    [4.169, 51.297],
    [4.208, 51.331],
    [4.214, 51.341],
    [4.221, 51.364],
    [4.221, 51.368],
    [4.222, 51.368],
    [4.241, 51.357],
    [4.249, 51.347],
    [4.256, 51.328],
    [4.273, 51.316],
    [4.291, 51.306],
    [4.303, 51.296],
    [4.307, 51.29],
    [4.308, 51.284],
    [4.305, 51.277],
    [4.299, 51.27],
    [4.297, 51.268],
    [4.308, 51.271],
    [4.316, 51.277],
    [4.331, 51.296],
    [4.297, 51.305],
    [4.289, 51.309],
    [4.285, 51.318],
    [4.286, 51.34],
    [4.283, 51.35],
    [4.276, 51.358],
    [4.261, 51.369],
    [4.281, 51.369],
    [4.29, 51.369],
    [4.326, 51.356],
    [4.346, 51.352],
    [4.392, 51.35],
    [4.411, 51.357],
    [4.416, 51.374],
    [4.41, 51.384],
    [4.388, 51.401],
    [4.38, 51.41],
    [4.381, 51.42],
    [4.387, 51.427],
    [4.389, 51.435],
    [4.377, 51.443],
    [4.429, 51.462],
    [4.483, 51.474],
    [4.513, 51.477],
    [4.525, 51.476],
    [4.533, 51.468],
    [4.532, 51.451],
    [4.523, 51.438],
    [4.522, 51.429],
    [4.541, 51.42],
    [4.554, 51.419],
    [4.583, 51.423],
    [4.615, 51.418],
    [4.63, 51.418],
    [4.644, 51.421],
    [4.654, 51.426],
    [4.731, 51.486],
    [4.764, 51.496],
    [4.779, 51.495],
    [4.797, 51.491],
    [4.814, 51.484],
    [4.824, 51.476],
    [4.826, 51.461],
    [4.82, 51.446],
    [4.815, 51.431],
    [4.823, 51.414],
    [4.779, 51.426],
    [4.768, 51.425],
    [4.762, 51.413],
    [4.783, 51.408],
    [4.853, 51.406],
    [4.872, 51.403],
    [4.91, 51.392],
    [4.932, 51.396],
    [4.957, 51.411],
    [4.98, 51.431],
    [4.996, 51.447],
    [5.003, 51.459],
    [5.006, 51.468],
    [5.012, 51.474],
    [5.028, 51.477],
    [5.03, 51.474],
    [5.06, 51.462],
    [5.08, 51.439],
    [5.076, 51.422],
    [5.065, 51.406],
    [5.062, 51.384],
    [5.068, 51.375],
    [5.103, 51.351],
    [5.108, 51.342],
    [5.118, 51.32],
    [5.123, 51.313],
    [5.14, 51.307],
    [5.179, 51.31],
    [5.197, 51.308],
    [5.215, 51.294],
    [5.215, 51.259],
    [5.233, 51.256],
    [5.239, 51.257],
    [5.271, 51.262],
    [5.389, 51.259],
    [5.41, 51.264],
    [5.452, 51.282],
    [5.472, 51.288],
    [5.493, 51.287],
    [5.517, 51.277],
    [5.535, 51.262],
    [5.542, 51.243],
    [5.546, 51.22],
    [5.551, 51.217],
    [5.568, 51.208],
    [5.625, 51.197],
    [5.639, 51.191],
    [5.648, 51.184],
    [5.659, 51.179],
    [5.676, 51.179],
    [5.718, 51.185],
    [5.731, 51.184],
    [5.747, 51.178],
    [5.768, 51.159],
    [5.781, 51.152],
    [5.812, 51.157],
    [5.829, 51.156],
    [5.838, 51.144],
    [5.841, 51.139],
    [5.826, 51.13],
    [5.823, 51.119],
    [5.846, 51.103],
    [5.837, 51.099],
    [5.827, 51.097],
    [5.816, 51.096],
    [5.805, 51.097],
    [5.807, 51.089],
    [5.809, 51.086],
    [5.812, 51.082],
    [5.804, 51.069],
    [5.799, 51.061],
    [5.791, 51.055],
    [5.78, 51.061],
    [5.771, 51.058],
    [5.766, 51.048],
    [5.764, 51.035],
    [5.778, 51.024],
    [5.762, 50.999],
    [5.722, 50.959],
    [5.745, 50.963],
    [5.754, 50.963],
    [5.764, 50.959],
    [5.753, 50.947],
    [5.735, 50.924],
    [5.722, 50.912],
    [5.718, 50.909],
    [5.706, 50.907],
    [5.694, 50.904],
    [5.622, 50.853],
    [5.624, 50.83],
    [5.641, 50.815],
    [5.657, 50.808],
    [5.663, 50.805],
    [5.685, 50.799],
    [5.7, 50.796],
    [5.699, 50.784],
    [5.688, 50.761],
    [5.707, 50.754],
    [5.717, 50.753],
    [5.728, 50.754],
    [5.733, 50.759],
    [5.744, 50.769],
    [5.752, 50.773],
    [5.762, 50.771],
    [5.783, 50.757],
    [5.793, 50.752],
    [5.88, 50.754],
    [5.891, 50.751],
    [5.902, 50.749],
    [5.975, 50.748],
    [5.995, 50.75],
    [5.993, 50.748],
    [5.993, 50.746],
    [5.993, 50.744],
    [5.994, 50.743],
    [6.011, 50.737],
    [6.011, 50.727],
    [6.008, 50.717],
    [6.012, 50.709],
    [6.025, 50.708],
    [6.064, 50.714],
    [6.081, 50.713],
    [6.1, 50.701],
    [6.161, 50.642],
    [6.148, 50.637],
    [6.159, 50.622],
    [6.18, 50.616],
    [6.249, 50.614],
    [6.251, 50.608],
    [6.245, 50.6],
    [3.25, 50.6],
    [3.238, 50.626],
    [3.23, 50.655],
    [3.244, 50.672],
    [3.232, 50.696],
    [3.224, 50.705],
    [3.211, 50.708],
    [3.197, 50.709],
    [3.189, 50.715],
    [3.177, 50.734],
    [3.163, 50.75],
    [3.146, 50.769],
    [3.129, 50.779],
    [3.103, 50.784],
    [3.024, 50.768],
    [2.971, 50.758],
    [2.948, 50.749],
    [2.93, 50.736],
    [2.9, 50.703],
    [2.887, 50.697],
    [2.871, 50.699],
    [2.867, 50.7],
    [2.787, 50.723],
    [2.768, 50.733],
    [2.763, 50.739],
    [2.75, 50.76],
    [2.744, 50.766],
    [2.707, 50.789],
    [2.7, 50.796],
    [2.697, 50.803],
    [2.692, 50.809],
    [2.679, 50.813],
    [2.669, 50.814],
    [2.66, 50.813],
  ],
];

/** Buurland-kustlijnen/-grenzen als open polylijnen (alleen stroke; cliprand uitgesloten). */
export const NEIGHBOR_COAST: ReadonlyArray<GeoRing> = [
  [
    [2.66, 50.813],
    [2.669, 50.814],
    [2.679, 50.813],
    [2.692, 50.809],
    [2.697, 50.803],
    [2.7, 50.796],
    [2.707, 50.789],
    [2.744, 50.766],
    [2.75, 50.76],
    [2.763, 50.739],
    [2.768, 50.733],
    [2.787, 50.723],
    [2.867, 50.7],
    [2.871, 50.699],
    [2.887, 50.697],
    [2.9, 50.703],
    [2.93, 50.736],
    [2.948, 50.749],
    [2.971, 50.758],
    [3.024, 50.768],
    [3.103, 50.784],
    [3.129, 50.779],
    [3.146, 50.769],
    [3.163, 50.75],
    [3.177, 50.734],
    [3.189, 50.715],
    [3.197, 50.709],
    [3.211, 50.708],
    [3.224, 50.705],
    [3.232, 50.696],
    [3.244, 50.672],
    [3.23, 50.655],
    [3.238, 50.626],
    [3.25, 50.6],
  ],
  [
    [6.245, 50.6],
    [6.251, 50.608],
    [6.249, 50.614],
    [6.18, 50.616],
    [6.159, 50.622],
    [6.148, 50.637],
    [6.161, 50.642],
    [6.1, 50.701],
    [6.081, 50.713],
    [6.064, 50.714],
    [6.025, 50.708],
    [6.012, 50.709],
    [6.008, 50.717],
    [6.011, 50.727],
    [6.011, 50.737],
    [5.994, 50.743],
    [5.993, 50.744],
    [5.993, 50.746],
    [5.993, 50.748],
    [5.995, 50.75],
    [5.997, 50.763],
    [5.991, 50.769],
    [5.981, 50.773],
    [5.973, 50.782],
    [5.969, 50.795],
    [5.984, 50.792],
    [5.998, 50.801],
    [6.004, 50.813],
    [6.001, 50.822],
    [6.0, 50.83],
    [6.009, 50.84],
    [6.023, 50.845],
    [6.046, 50.844],
    [6.057, 50.853],
    [6.063, 50.863],
    [6.063, 50.871],
    [6.055, 50.891],
    [6.057, 50.898],
    [6.062, 50.904],
    [6.064, 50.908],
    [6.031, 50.915],
    [6.008, 50.924],
    [6.0, 50.929],
    [5.997, 50.937],
    [5.996, 50.952],
    [6.0, 50.96],
    [6.006, 50.969],
    [6.004, 50.974],
    [5.968, 50.971],
    [5.942, 50.976],
    [5.928, 50.978],
    [5.914, 50.975],
    [5.888, 50.967],
    [5.875, 50.965],
    [5.874, 50.991],
    [5.858, 51.019],
    [5.852, 51.043],
    [5.88, 51.052],
    [5.894, 51.047],
    [5.906, 51.037],
    [5.92, 51.03],
    [5.938, 51.031],
    [5.95, 51.039],
    [5.969, 51.065],
    [5.983, 51.075],
    [6.075, 51.12],
    [6.132, 51.14],
    [6.147, 51.152],
    [6.126, 51.165],
    [6.149, 51.176],
    [6.157, 51.179],
    [6.134, 51.184],
    [6.084, 51.163],
    [6.061, 51.171],
    [6.054, 51.189],
    [6.057, 51.212],
    [6.065, 51.232],
    [6.075, 51.243],
    [6.097, 51.259],
    [6.148, 51.318],
    [6.158, 51.325],
    [6.184, 51.336],
    [6.194, 51.345],
    [6.199, 51.357],
    [6.202, 51.379],
    [6.208, 51.388],
    [6.193, 51.399],
    [6.194, 51.417],
    [6.202, 51.439],
    [6.205, 51.458],
    [6.2, 51.477],
    [6.193, 51.509],
    [6.153, 51.538],
    [6.086, 51.596],
    [6.082, 51.608],
    [6.088, 51.622],
    [6.099, 51.644],
    [6.031, 51.663],
    [6.009, 51.681],
    [6.022, 51.71],
    [6.012, 51.716],
    [5.99, 51.726],
    [5.978, 51.73],
    [5.949, 51.729],
    [5.939, 51.732],
    [5.94, 51.743],
    [5.946, 51.746],
    [5.962, 51.756],
    [5.964, 51.777],
    [5.951, 51.796],
    [5.928, 51.807],
    [5.931, 51.816],
    [5.948, 51.823],
    [5.989, 51.827],
    [6.008, 51.833],
    [6.029, 51.842],
    [6.043, 51.847],
    [6.084, 51.854],
    [6.116, 51.848],
    [6.14, 51.845],
    [6.156, 51.842],
    [6.143, 51.855],
    [6.105, 51.879],
    [6.093, 51.885],
    [6.127, 51.897],
    [6.159, 51.887],
    [6.191, 51.871],
    [6.225, 51.863],
    [6.256, 51.867],
    [6.265, 51.866],
    [6.272, 51.862],
    [6.283, 51.85],
    [6.287, 51.846],
    [6.326, 51.843],
    [6.342, 51.837],
    [6.345, 51.821],
    [6.382, 51.828],
    [6.387, 51.838],
    [6.378, 51.86],
    [6.443, 51.848],
    [6.463, 51.848],
    [6.479, 51.853],
    [6.529, 51.876],
    [6.628, 51.898],
    [6.717, 51.899],
    [6.744, 51.908],
    [6.767, 51.926],
    [6.79, 51.951],
    [6.798, 51.957],
    [6.806, 51.958],
    [6.811, 51.961],
    [6.812, 51.973],
    [6.809, 51.98],
    [6.804, 51.984],
    [6.778, 52.001],
    [6.713, 52.024],
    [6.691, 52.028],
    [6.675, 52.035],
    [6.673, 52.05],
    [6.68, 52.06],
    [6.689, 52.063],
    [6.699, 52.064],
    [6.711, 52.067],
    [6.719, 52.074],
    [6.728, 52.086],
    [6.733, 52.092],
    [6.75, 52.103],
    [6.766, 52.108],
    [6.772, 52.109],
    [6.831, 52.113],
    [6.843, 52.12],
    [6.865, 52.148],
    [6.885, 52.16],
    [6.928, 52.172],
    [6.948, 52.183],
    [6.971, 52.206],
    [6.982, 52.214],
    [7.026, 52.231],
    [7.029, 52.236],
    [7.027, 52.239],
    [7.021, 52.245],
    [7.012, 52.267],
    [7.012, 52.285],
    [7.02, 52.3],
    [7.04, 52.329],
    [7.048, 52.365],
    [7.034, 52.391],
    [6.973, 52.451],
    [6.967, 52.45],
    [6.961, 52.443],
    [6.951, 52.437],
    [6.926, 52.433],
    [6.9, 52.432],
    [6.872, 52.435],
    [6.82, 52.447],
    [6.741, 52.454],
    [6.715, 52.462],
    [6.695, 52.476],
    [6.689, 52.491],
    [6.688, 52.508],
    [6.684, 52.526],
    [6.672, 52.542],
    [6.688, 52.543],
    [6.744, 52.56],
    [6.711, 52.577],
    [6.704, 52.583],
    [6.704, 52.591],
    [6.708, 52.6],
    [6.71, 52.609],
    [6.702, 52.619],
    [6.719, 52.627],
    [6.737, 52.635],
    [6.771, 52.641],
    [6.865, 52.642],
    [6.918, 52.632],
    [6.968, 52.637],
    [6.983, 52.633],
    [7.018, 52.626],
    [7.037, 52.647],
    [7.044, 52.683],
    [7.053, 52.791],
    [7.062, 52.824],
    [7.072, 52.841],
    [7.08, 52.854],
    [7.162, 52.933],
    [7.184, 52.966],
    [7.193, 52.998],
    [7.194, 53.034],
    [7.185, 53.105],
    [7.181, 53.114],
    [7.176, 53.119],
    [7.173, 53.126],
    [7.172, 53.138],
    [7.174, 53.146],
    [7.189, 53.168],
    [7.195, 53.185],
    [7.199, 53.201],
    [7.197, 53.217],
    [7.195, 53.245],
    [7.204, 53.248],
    [7.216, 53.256],
    [7.225, 53.263],
    [7.234, 53.274],
    [7.237, 53.286],
    [7.23, 53.297],
    [7.255, 53.32],
    [7.268, 53.324],
    [7.292, 53.324],
    [7.313, 53.321],
    [7.348, 53.307],
    [7.367, 53.303],
    [7.343, 53.324],
    [7.303, 53.333],
    [7.075, 53.338],
    [7.038, 53.349],
    [7.024, 53.376],
    [7.023, 53.451],
    [7.028, 53.467],
    [7.047, 53.498],
    [7.051, 53.513],
    [7.06, 53.522],
    [7.079, 53.522],
    [7.12, 53.516],
    [7.125, 53.524],
    [7.135, 53.527],
    [7.142, 53.537],
    [7.14, 53.55],
    [7.131, 53.557],
    [7.102, 53.566],
    [7.089, 53.574],
    [7.087, 53.587],
    [7.101, 53.598],
    [7.133, 53.611],
    [7.169, 53.635],
    [7.189, 53.644],
    [7.226, 53.666],
    [7.305, 53.685],
    [7.459, 53.695],
    [7.47, 53.691],
    [7.48, 53.682],
    [7.504, 53.679],
    [7.651, 53.697],
    [7.808, 53.71],
  ],
  [
    [6.798, 53.604],
    [6.776, 53.602],
    [6.741, 53.593],
    [6.722, 53.591],
    [6.722, 53.585],
    [6.734, 53.582],
    [6.742, 53.578],
    [6.75, 53.572],
    [6.757, 53.563],
    [6.748, 53.566],
    [6.735, 53.575],
    [6.726, 53.577],
    [6.716, 53.576],
    [6.701, 53.571],
    [6.695, 53.57],
    [6.677, 53.576],
    [6.663, 53.587],
    [6.66, 53.599],
    [6.671, 53.604],
    [6.747, 53.618],
    [6.785, 53.62],
    [6.798, 53.604],
  ],
  [
    [6.874, 53.673],
    [6.911, 53.684],
    [7.047, 53.694],
    [7.085, 53.687],
    [6.874, 53.673],
  ],
  [
    [7.133, 53.708],
    [7.139, 53.71],
  ],
  [
    [7.283, 53.71],
    [7.174, 53.701],
    [7.133, 53.708],
  ],
  [
    [2.66, 51.143],
    [2.716, 51.17],
    [2.924, 51.246],
    [3.125, 51.33],
    [3.349, 51.375],
    [3.358, 51.337],
    [3.354, 51.312],
    [3.353, 51.289],
    [3.367, 51.263],
    [3.392, 51.247],
    [3.399, 51.245],
    [3.422, 51.238],
    [3.454, 51.236],
    [3.501, 51.24],
    [3.504, 51.25],
    [3.502, 51.262],
    [3.503, 51.274],
    [3.514, 51.281],
    [3.529, 51.283],
    [3.545, 51.284],
    [3.585, 51.29],
    [3.61, 51.29],
    [3.635, 51.288],
    [3.757, 51.262],
    [3.776, 51.255],
    [3.781, 51.241],
    [3.78, 51.23],
    [3.781, 51.22],
    [3.796, 51.209],
    [3.809, 51.205],
    [3.927, 51.206],
    [3.949, 51.211],
    [3.995, 51.233],
    [4.119, 51.272],
    [4.169, 51.297],
    [4.208, 51.331],
    [4.214, 51.341],
    [4.221, 51.364],
    [4.221, 51.368],
    [4.222, 51.368],
    [4.241, 51.357],
    [4.249, 51.347],
    [4.256, 51.328],
    [4.273, 51.316],
    [4.291, 51.306],
    [4.303, 51.296],
    [4.307, 51.29],
    [4.308, 51.284],
    [4.305, 51.277],
    [4.299, 51.27],
    [4.297, 51.268],
    [4.308, 51.271],
    [4.316, 51.277],
    [4.331, 51.296],
    [4.297, 51.305],
    [4.289, 51.309],
    [4.285, 51.318],
    [4.286, 51.34],
    [4.283, 51.35],
    [4.276, 51.358],
    [4.261, 51.369],
    [4.281, 51.369],
    [4.29, 51.369],
    [4.326, 51.356],
    [4.346, 51.352],
    [4.392, 51.35],
    [4.411, 51.357],
    [4.416, 51.374],
    [4.41, 51.384],
    [4.388, 51.401],
    [4.38, 51.41],
    [4.381, 51.42],
    [4.387, 51.427],
    [4.389, 51.435],
    [4.377, 51.443],
    [4.429, 51.462],
    [4.483, 51.474],
    [4.513, 51.477],
    [4.525, 51.476],
    [4.533, 51.468],
    [4.532, 51.451],
    [4.523, 51.438],
    [4.522, 51.429],
    [4.541, 51.42],
    [4.554, 51.419],
    [4.583, 51.423],
    [4.615, 51.418],
    [4.63, 51.418],
    [4.644, 51.421],
    [4.654, 51.426],
    [4.731, 51.486],
    [4.764, 51.496],
    [4.779, 51.495],
    [4.797, 51.491],
    [4.814, 51.484],
    [4.824, 51.476],
    [4.826, 51.461],
    [4.82, 51.446],
    [4.815, 51.431],
    [4.823, 51.414],
    [4.779, 51.426],
    [4.768, 51.425],
    [4.762, 51.413],
    [4.783, 51.408],
    [4.853, 51.406],
    [4.872, 51.403],
    [4.91, 51.392],
    [4.932, 51.396],
    [4.957, 51.411],
    [4.98, 51.431],
    [4.996, 51.447],
    [5.003, 51.459],
    [5.006, 51.468],
    [5.012, 51.474],
    [5.028, 51.477],
    [5.03, 51.474],
    [5.06, 51.462],
    [5.08, 51.439],
    [5.076, 51.422],
    [5.065, 51.406],
    [5.062, 51.384],
    [5.068, 51.375],
    [5.103, 51.351],
    [5.108, 51.342],
    [5.118, 51.32],
    [5.123, 51.313],
    [5.14, 51.307],
    [5.179, 51.31],
    [5.197, 51.308],
    [5.215, 51.294],
    [5.215, 51.259],
    [5.233, 51.256],
    [5.239, 51.257],
    [5.271, 51.262],
    [5.389, 51.259],
    [5.41, 51.264],
    [5.452, 51.282],
    [5.472, 51.288],
    [5.493, 51.287],
    [5.517, 51.277],
    [5.535, 51.262],
    [5.542, 51.243],
    [5.546, 51.22],
    [5.551, 51.217],
    [5.568, 51.208],
    [5.625, 51.197],
    [5.639, 51.191],
    [5.648, 51.184],
    [5.659, 51.179],
    [5.676, 51.179],
    [5.718, 51.185],
    [5.731, 51.184],
    [5.747, 51.178],
    [5.768, 51.159],
    [5.781, 51.152],
    [5.812, 51.157],
    [5.829, 51.156],
    [5.838, 51.144],
    [5.841, 51.139],
    [5.826, 51.13],
    [5.823, 51.119],
    [5.846, 51.103],
    [5.837, 51.099],
    [5.827, 51.097],
    [5.816, 51.096],
    [5.805, 51.097],
    [5.807, 51.089],
    [5.809, 51.086],
    [5.812, 51.082],
    [5.804, 51.069],
    [5.799, 51.061],
    [5.791, 51.055],
    [5.78, 51.061],
    [5.771, 51.058],
    [5.766, 51.048],
    [5.764, 51.035],
    [5.778, 51.024],
    [5.762, 50.999],
    [5.722, 50.959],
    [5.745, 50.963],
    [5.754, 50.963],
    [5.764, 50.959],
    [5.753, 50.947],
    [5.735, 50.924],
    [5.722, 50.912],
    [5.718, 50.909],
    [5.706, 50.907],
    [5.694, 50.904],
    [5.622, 50.853],
    [5.624, 50.83],
    [5.641, 50.815],
    [5.657, 50.808],
    [5.663, 50.805],
    [5.685, 50.799],
    [5.7, 50.796],
    [5.699, 50.784],
    [5.688, 50.761],
    [5.707, 50.754],
    [5.717, 50.753],
    [5.728, 50.754],
    [5.733, 50.759],
    [5.744, 50.769],
    [5.752, 50.773],
    [5.762, 50.771],
    [5.783, 50.757],
    [5.793, 50.752],
    [5.88, 50.754],
    [5.891, 50.751],
    [5.902, 50.749],
    [5.975, 50.748],
    [5.995, 50.75],
    [5.993, 50.748],
    [5.993, 50.746],
    [5.993, 50.744],
    [5.994, 50.743],
    [6.011, 50.737],
    [6.011, 50.727],
    [6.008, 50.717],
    [6.012, 50.709],
    [6.025, 50.708],
    [6.064, 50.714],
    [6.081, 50.713],
    [6.1, 50.701],
    [6.161, 50.642],
    [6.148, 50.637],
    [6.159, 50.622],
    [6.18, 50.616],
    [6.249, 50.614],
    [6.251, 50.608],
    [6.245, 50.6],
  ],
  [
    [3.25, 50.6],
    [3.238, 50.626],
    [3.23, 50.655],
    [3.244, 50.672],
    [3.232, 50.696],
    [3.224, 50.705],
    [3.211, 50.708],
    [3.197, 50.709],
    [3.189, 50.715],
    [3.177, 50.734],
    [3.163, 50.75],
    [3.146, 50.769],
    [3.129, 50.779],
    [3.103, 50.784],
    [3.024, 50.768],
    [2.971, 50.758],
    [2.948, 50.749],
    [2.93, 50.736],
    [2.9, 50.703],
    [2.887, 50.697],
    [2.871, 50.699],
    [2.867, 50.7],
    [2.787, 50.723],
    [2.768, 50.733],
    [2.763, 50.739],
    [2.75, 50.76],
    [2.744, 50.766],
    [2.707, 50.789],
    [2.7, 50.796],
    [2.697, 50.803],
    [2.692, 50.809],
    [2.679, 50.813],
    [2.669, 50.814],
    [2.66, 50.813],
  ],
];

/** NL-provinciegrenzen (open polylijnen, dun te stroken). */
export const NL_PROVINCES: ReadonlyArray<GeoRing> = [
  [
    [4.186, 51.617],
    [4.186, 51.61],
    [4.199, 51.602],
    [4.207, 51.591],
  ],
  [
    [4.23, 51.519],
    [4.232, 51.501],
    [4.234, 51.489],
    [4.242, 51.475],
    [4.25, 51.461],
    [4.264, 51.444],
  ],
  [
    [4.954, 53.171],
    [4.835, 53.22],
  ],
  [
    [4.198, 51.638],
    [4.197, 51.637],
    [4.186, 51.617],
  ],
  [
    [4.207, 51.591],
    [4.208, 51.59],
    [4.234, 51.571],
    [4.237, 51.568],
    [4.244, 51.555],
    [4.244, 51.543],
    [4.243, 51.539],
    [4.23, 51.52],
  ],
  [
    [4.264, 51.444],
    [4.269, 51.429],
    [4.265, 51.425],
    [4.264, 51.422],
    [4.262, 51.419],
    [4.263, 51.407],
    [4.267, 51.388],
    [4.276, 51.383],
    [4.28, 51.377],
    [4.281, 51.369],
  ],
  [
    [4.566, 52.31],
    [4.549, 52.313],
    [4.543, 52.314],
    [4.499, 52.326],
  ],
  [
    [4.548, 52.22],
    [4.547, 52.228],
    [4.559, 52.241],
    [4.564, 52.254],
    [4.565, 52.264],
    [4.566, 52.268],
    [4.568, 52.271],
    [4.61, 52.313],
    [4.587, 52.317],
  ],
  [
    [4.587, 52.317],
    [4.566, 52.31],
  ],
  [
    [4.736, 52.208],
    [4.726, 52.211],
    [4.722, 52.216],
    [4.718, 52.231],
    [4.715, 52.232],
    [4.71, 52.235],
  ],
  [
    [4.71, 52.235],
    [4.669, 52.226],
    [4.648, 52.22],
    [4.606, 52.213],
    [4.581, 52.213],
  ],
  [
    [4.768, 52.221],
    [4.736, 52.208],
  ],
  [
    [4.581, 52.213],
    [4.574, 52.214],
    [4.569, 52.215],
    [4.559, 52.221],
  ],
  [
    [4.559, 52.221],
    [4.548, 52.22],
  ],
  [
    [5.74, 52.839],
    [5.75, 52.835],
    [5.775, 52.819],
    [5.785, 52.804],
  ],
  [
    [5.72, 52.837],
    [5.74, 52.839],
  ],
  [
    [5.188, 52.991],
    [5.187, 52.992],
    [5.186, 52.995],
    [5.182, 53.005],
    [5.18, 53.008],
    [5.18, 53.009],
  ],
  [
    [5.183, 51.967],
    [5.158, 51.935],
    [5.153, 51.93],
    [5.118, 51.892],
    [5.12, 51.886],
    [5.121, 51.881],
    [5.121, 51.878],
    [5.121, 51.876],
    [5.11, 51.872],
    [5.033, 51.852],
    [5.004, 51.851],
    [5.011, 51.845],
    [5.011, 51.843],
    [5.008, 51.835],
    [5.009, 51.825],
  ],
  [
    [5.409, 52.268],
    [5.409, 52.267],
    [5.403, 52.248],
    [5.399, 52.231],
    [5.397, 52.22],
    [5.402, 52.214],
    [5.439, 52.196],
    [5.437, 52.186],
    [5.433, 52.182],
    [5.427, 52.179],
    [5.425, 52.177],
    [5.424, 52.175],
    [5.43, 52.169],
    [5.454, 52.164],
    [5.475, 52.161],
    [5.482, 52.158],
    [5.49, 52.149],
    [5.494, 52.147],
    [5.502, 52.144],
    [5.51, 52.139],
    [5.513, 52.136],
    [5.513, 52.133],
    [5.508, 52.127],
    [5.508, 52.12],
    [5.509, 52.117],
    [5.509, 52.115],
    [5.508, 52.113],
  ],
  [
    [5.508, 52.113],
    [5.498, 52.114],
  ],
  [
    [5.498, 52.114],
    [5.49, 52.104],
    [5.484, 52.093],
    [5.481, 52.09],
    [5.476, 52.086],
    [5.469, 52.082],
    [5.47, 52.08],
    [5.472, 52.078],
    [5.5, 52.07],
  ],
  [
    [5.553, 52.105],
    [5.562, 52.085],
    [5.563, 52.079],
    [5.565, 52.073],
    [5.563, 52.049],
    [5.572, 52.019],
    [5.585, 52.005],
    [5.605, 51.991],
    [5.612, 51.982],
    [5.616, 51.978],
    [5.618, 51.974],
    [5.62, 51.969],
    [5.619, 51.953],
    [5.616, 51.948],
  ],
  [
    [5.5, 52.07],
    [5.509, 52.072],
    [5.52, 52.077],
    [5.523, 52.078],
    [5.527, 52.078],
    [5.531, 52.08],
    [5.535, 52.082],
    [5.539, 52.087],
    [5.541, 52.091],
    [5.541, 52.095],
    [5.537, 52.102],
    [5.553, 52.105],
  ],
  [
    [5.616, 51.948],
    [5.582, 51.953],
    [5.505, 51.982],
    [5.462, 51.988],
  ],
  [
    [5.462, 51.988],
    [5.449, 51.986],
    [5.43, 51.977],
    [5.42, 51.974],
  ],
  [
    [5.42, 51.974],
    [5.409, 51.974],
    [5.383, 51.98],
  ],
  [
    [5.383, 51.98],
    [5.361, 51.977],
    [5.331, 51.963],
    [5.311, 51.96],
  ],
  [
    [5.311, 51.96],
    [5.254, 51.979],
  ],
  [
    [5.254, 51.979],
    [5.239, 51.977],
    [5.221, 51.968],
    [5.197, 51.966],
  ],
  [
    [5.197, 51.966],
    [5.183, 51.967],
  ],
  [
    [5.941, 51.745],
    [5.916, 51.756],
    [5.912, 51.758],
    [5.894, 51.773],
    [5.89, 51.777],
    [5.887, 51.778],
    [5.882, 51.778],
  ],
  [
    [5.882, 51.778],
    [5.872, 51.777],
    [5.863, 51.773],
    [5.863, 51.759],
  ],
  [
    [5.946, 51.746],
    [5.945, 51.746],
    [5.941, 51.745],
  ],
  [
    [5.93, 52.616],
    [5.94, 52.617],
    [5.988, 52.627],
    [6.02, 52.638],
    [5.998, 52.654],
    [5.978, 52.66],
    [5.938, 52.668],
    [5.929, 52.67],
    [5.927, 52.672],
    [5.928, 52.673],
    [5.936, 52.678],
    [5.94, 52.683],
    [5.945, 52.689],
    [5.938, 52.714],
    [5.923, 52.74],
    [5.916, 52.747],
    [5.905, 52.756],
    [5.858, 52.779],
    [5.785, 52.804],
  ],
  [
    [5.908, 52.62],
    [5.914, 52.618],
    [5.93, 52.616],
  ],
  [
    [5.844, 52.605],
    [5.895, 52.619],
    [5.908, 52.62],
  ],
  [
    [6.032, 52.821],
    [6.047, 52.831],
    [6.048, 52.833],
    [6.048, 52.837],
    [6.05, 52.838],
    [6.052, 52.839],
    [6.068, 52.842],
    [6.087, 52.843],
    [6.129, 52.853],
  ],
  [
    [5.959, 52.842],
    [5.962, 52.841],
    [5.967, 52.84],
    [5.979, 52.829],
    [5.988, 52.824],
    [5.993, 52.823],
    [6.032, 52.821],
  ],
  [
    [5.866, 52.805],
    [5.872, 52.805],
    [5.879, 52.806],
    [5.909, 52.817],
    [5.914, 52.82],
    [5.918, 52.824],
    [5.922, 52.828],
    [5.924, 52.831],
    [5.928, 52.833],
    [5.933, 52.835],
    [5.953, 52.838],
    [5.957, 52.84],
    [5.959, 52.842],
  ],
  [
    [5.822, 52.815],
    [5.834, 52.809],
    [5.838, 52.808],
    [5.866, 52.805],
  ],
  [
    [5.785, 52.804],
    [5.822, 52.815],
  ],
  [
    [5.867, 52.522],
    [5.881, 52.521],
    [5.891, 52.52],
    [5.904, 52.509],
    [5.925, 52.484],
    [5.931, 52.481],
    [5.939, 52.479],
  ],
  [
    [6.031, 52.511],
    [6.043, 52.508],
    [6.05, 52.505],
    [6.056, 52.499],
    [6.064, 52.489],
    [6.082, 52.478],
    [6.089, 52.474],
    [6.095, 52.468],
    [6.104, 52.452],
    [6.112, 52.44],
    [6.133, 52.421],
    [6.135, 52.419],
    [6.136, 52.416],
    [6.135, 52.404],
    [6.12, 52.38],
    [6.087, 52.373],
    [6.084, 52.372],
    [6.082, 52.371],
    [6.087, 52.364],
    [6.087, 52.359],
    [6.078, 52.351],
    [6.069, 52.329],
    [6.068, 52.322],
    [6.071, 52.318],
    [6.081, 52.309],
    [6.086, 52.306],
    [6.107, 52.3],
    [6.125, 52.271],
    [6.124, 52.263],
    [6.122, 52.259],
    [6.124, 52.256],
    [6.128, 52.254],
    [6.139, 52.251],
    [6.144, 52.249],
    [6.146, 52.244],
    [6.142, 52.237],
    [6.142, 52.235],
    [6.143, 52.233],
    [6.146, 52.23],
    [6.154, 52.226],
    [6.158, 52.225],
  ],
  [
    [5.939, 52.479],
    [5.97, 52.485],
    [6.002, 52.502],
    [6.031, 52.511],
  ],
  [
    [6.382, 52.247],
    [6.411, 52.245],
    [6.417, 52.238],
    [6.418, 52.237],
    [6.466, 52.194],
    [6.495, 52.177],
  ],
  [
    [6.259, 52.229],
    [6.323, 52.229],
    [6.332, 52.231],
    [6.347, 52.238],
    [6.382, 52.247],
  ],
  [
    [6.18, 52.238],
    [6.189, 52.237],
    [6.259, 52.229],
  ],
  [
    [6.158, 52.225],
    [6.16, 52.225],
    [6.167, 52.232],
    [6.177, 52.237],
    [6.18, 52.238],
  ],
  [
    [6.586, 52.18],
    [6.592, 52.179],
    [6.597, 52.178],
    [6.601, 52.173],
    [6.602, 52.169],
    [6.602, 52.166],
    [6.606, 52.165],
    [6.61, 52.165],
  ],
  [
    [6.558, 52.176],
    [6.586, 52.18],
  ],
  [
    [6.519, 52.179],
    [6.558, 52.176],
  ],
  [
    [6.495, 52.177],
    [6.519, 52.179],
  ],
  [
    [6.646, 52.17],
    [6.654, 52.168],
    [6.663, 52.166],
    [6.667, 52.164],
    [6.669, 52.162],
    [6.671, 52.158],
    [6.672, 52.148],
    [6.672, 52.142],
    [6.662, 52.127],
    [6.76, 52.114],
    [6.771, 52.109],
    [6.772, 52.109],
  ],
  [
    [6.61, 52.165],
    [6.646, 52.17],
  ],
  [
    [5.863, 51.759],
    [5.883, 51.753],
    [5.88, 51.741],
    [5.888, 51.729],
    [5.904, 51.723],
    [5.945, 51.72],
    [5.96, 51.712],
    [5.973, 51.676],
    [5.989, 51.666],
    [5.982, 51.656],
    [5.987, 51.651],
    [5.997, 51.647],
    [6.006, 51.641],
    [6.026, 51.621],
    [6.027, 51.617],
    [6.031, 51.613],
    [6.044, 51.583],
    [6.049, 51.575],
    [6.049, 51.566],
    [6.034, 51.558],
  ],
  [
    [6.034, 51.558],
    [6.009, 51.568],
    [6.0, 51.57],
  ],
  [
    [6.0, 51.57],
    [5.951, 51.559],
    [5.924, 51.557],
  ],
  [
    [5.924, 51.557],
    [5.912, 51.557],
    [5.874, 51.565],
    [5.838, 51.567],
  ],
  [
    [5.838, 51.567],
    [5.853, 51.504],
    [5.876, 51.447],
    [5.91, 51.417],
    [5.934, 51.385],
    [5.898, 51.366],
    [5.875, 51.354],
    [5.844, 51.349],
    [5.773, 51.335],
    [5.676, 51.316],
    [5.655, 51.299],
    [5.648, 51.292],
    [5.63, 51.273],
    [5.621, 51.239],
    [5.615, 51.232],
    [5.608, 51.227],
    [5.601, 51.225],
  ],
  [
    [5.601, 51.225],
    [5.592, 51.226],
  ],
  [
    [5.592, 51.226],
    [5.568, 51.221],
    [5.552, 51.217],
    [5.551, 51.217],
  ],
  [
    [5.501, 51.835],
    [5.52, 51.827],
    [5.535, 51.824],
  ],
  [
    [5.441, 51.816],
    [5.462, 51.821],
    [5.482, 51.83],
    [5.501, 51.835],
  ],
  [
    [5.599, 51.83],
    [5.643, 51.824],
    [5.649, 51.819],
    [5.661, 51.8],
    [5.671, 51.796],
    [5.69, 51.793],
    [5.76, 51.763],
    [5.863, 51.759],
  ],
  [
    [5.535, 51.824],
    [5.599, 51.83],
  ],
  [
    [5.009, 51.825],
    [5.01, 51.82],
    [5.012, 51.811],
    [5.028, 51.801],
    [5.065, 51.783],
    [5.089, 51.783],
  ],
  [
    [5.401, 51.818],
    [5.441, 51.816],
  ],
  [
    [5.135, 51.735],
    [5.318, 51.747],
    [5.337, 51.753],
    [5.355, 51.763],
    [5.368, 51.775],
    [5.373, 51.792],
    [5.381, 51.812],
    [5.401, 51.818],
  ],
  [
    [5.1, 51.785],
    [5.137, 51.769],
    [5.137, 51.753],
    [5.126, 51.737],
    [5.135, 51.735],
  ],
  [
    [5.089, 51.783],
    [5.1, 51.785],
  ],
  [
    [6.31, 53.092],
    [6.308, 53.078],
    [6.311, 53.077],
    [6.326, 53.071],
    [6.355, 53.064],
    [6.357, 53.061],
    [6.359, 53.055],
    [6.358, 53.05],
    [6.364, 53.04],
    [6.368, 53.028],
    [6.422, 52.985],
    [6.434, 52.969],
    [6.432, 52.965],
    [6.429, 52.959],
    [6.402, 52.932],
    [6.396, 52.928],
    [6.348, 52.908],
  ],
  [
    [6.348, 52.908],
    [6.314, 52.922],
    [6.292, 52.926],
  ],
  [
    [6.292, 52.926],
    [6.265, 52.926],
    [6.255, 52.92],
    [6.248, 52.916],
    [6.214, 52.893],
    [6.129, 52.853],
  ],
  [
    [6.191, 52.679],
    [6.183, 52.68],
    [6.179, 52.682],
    [6.177, 52.684],
    [6.17, 52.691],
    [6.165, 52.693],
    [6.13, 52.749],
    [6.14, 52.759],
    [6.166, 52.766],
    [6.202, 52.788],
    [6.207, 52.797],
    [6.198, 52.805],
    [6.187, 52.813],
    [6.18, 52.817],
    [6.129, 52.853],
  ],
  [
    [6.273, 52.668],
    [6.265, 52.67],
    [6.234, 52.683],
    [6.218, 52.686],
  ],
  [
    [6.218, 52.686],
    [6.211, 52.685],
    [6.205, 52.682],
    [6.197, 52.679],
    [6.191, 52.679],
  ],
  [
    [6.719, 52.627],
    [6.718, 52.627],
    [6.708, 52.631],
    [6.705, 52.639],
    [6.706, 52.647],
    [6.702, 52.649],
    [6.696, 52.652],
    [6.624, 52.672],
    [6.611, 52.673],
  ],
  [
    [6.611, 52.673],
    [6.582, 52.669],
    [6.533, 52.654],
    [6.521, 52.646],
    [6.519, 52.641],
    [6.522, 52.611],
  ],
  [
    [6.393, 52.618],
    [6.387, 52.618],
    [6.383, 52.62],
    [6.382, 52.621],
    [6.373, 52.634],
    [6.365, 52.642],
    [6.348, 52.652],
    [6.333, 52.66],
    [6.325, 52.668],
    [6.321, 52.668],
  ],
  [
    [6.321, 52.668],
    [6.273, 52.668],
  ],
  [
    [6.448, 52.618],
    [6.443, 52.619],
    [6.439, 52.622],
    [6.434, 52.627],
    [6.431, 52.628],
    [6.429, 52.628],
  ],
  [
    [6.429, 52.628],
    [6.424, 52.625],
    [6.417, 52.623],
    [6.393, 52.618],
  ],
  [
    [6.522, 52.611],
    [6.48, 52.624],
    [6.474, 52.624],
  ],
  [
    [6.474, 52.624],
    [6.467, 52.624],
    [6.462, 52.621],
    [6.454, 52.618],
    [6.448, 52.618],
  ],
  [
    [6.237, 53.344],
    [6.234, 53.345],
    [6.231, 53.346],
    [6.226, 53.349],
    [6.221, 53.354],
    [6.217, 53.356],
    [6.213, 53.357],
    [6.194, 53.361],
    [6.18, 53.364],
    [6.17, 53.386],
    [6.175, 53.398],
    [6.186, 53.411],
  ],
  [
    [6.31, 53.092],
    [6.301, 53.095],
    [6.265, 53.109],
    [6.248, 53.113],
    [6.205, 53.115],
    [6.196, 53.117],
    [6.183, 53.124],
    [6.174, 53.131],
    [6.169, 53.153],
    [6.176, 53.174],
    [6.186, 53.187],
    [6.223, 53.217],
    [6.226, 53.221],
    [6.226, 53.223],
    [6.225, 53.226],
    [6.223, 53.229],
    [6.221, 53.232],
    [6.22, 53.236],
    [6.218, 53.241],
    [6.23, 53.255],
    [6.245, 53.271],
    [6.25, 53.284],
    [6.254, 53.288],
    [6.268, 53.298],
    [6.284, 53.307],
    [6.287, 53.309],
    [6.287, 53.31],
    [6.28, 53.311],
    [6.278, 53.312],
    [6.276, 53.314],
    [6.277, 53.323],
    [6.279, 53.336],
    [6.277, 53.341],
    [6.274, 53.345],
    [6.255, 53.348],
  ],
  [
    [6.255, 53.348],
    [6.252, 53.348],
    [6.249, 53.348],
    [6.244, 53.345],
    [6.24, 53.344],
    [6.237, 53.344],
  ],
  [
    [6.468, 53.205],
    [6.501, 53.195],
    [6.52, 53.19],
  ],
  [
    [6.33, 53.088],
    [6.338, 53.091],
    [6.354, 53.108],
    [6.358, 53.118],
    [6.362, 53.125],
    [6.375, 53.141],
    [6.378, 53.146],
    [6.379, 53.148],
    [6.385, 53.158],
    [6.4, 53.17],
    [6.414, 53.178],
    [6.432, 53.185],
    [6.468, 53.205],
  ],
  [
    [6.531, 53.191],
    [6.548, 53.177],
    [6.564, 53.16],
    [6.567, 53.158],
    [6.572, 53.157],
    [6.583, 53.152],
    [6.617, 53.125],
    [6.628, 53.109],
    [6.63, 53.108],
    [6.631, 53.106],
  ],
  [
    [6.52, 53.19],
    [6.531, 53.191],
  ],
  [
    [6.699, 53.119],
    [6.725, 53.117],
    [6.735, 53.114],
    [6.741, 53.112],
    [6.776, 53.089],
    [6.819, 53.06],
    [6.843, 53.046],
    [6.862, 53.035],
    [6.897, 53.013],
    [6.935, 52.988],
    [6.982, 52.95],
    [7.031, 52.913],
    [7.038, 52.912],
    [7.039, 52.908],
    [7.039, 52.904],
    [7.018, 52.87],
    [7.038, 52.866],
    [7.048, 52.861],
    [7.066, 52.847],
    [7.072, 52.842],
    [7.072, 52.841],
  ],
  [
    [6.631, 53.106],
    [6.637, 53.107],
    [6.699, 53.119],
  ],
  [
    [6.31, 53.092],
    [6.33, 53.088],
  ],
  [
    [4.986, 52.285],
    [4.994, 52.285],
    [5.0, 52.284],
    [5.004, 52.282],
    [5.009, 52.277],
  ],
  [
    [4.942, 52.275],
    [4.962, 52.277],
    [4.986, 52.285],
  ],
  [
    [5.182, 52.179],
    [5.202, 52.187],
    [5.209, 52.197],
    [5.216, 52.207],
    [5.222, 52.214],
    [5.225, 52.226],
    [5.246, 52.257],
    [5.264, 52.276],
    [5.268, 52.277],
    [5.276, 52.279],
    [5.332, 52.279],
    [5.366, 52.283],
  ],
  [
    [5.025, 52.282],
    [5.066, 52.279],
    [5.035, 52.272],
    [5.03, 52.267],
    [5.034, 52.263],
    [5.035, 52.26],
    [5.036, 52.256],
    [5.038, 52.254],
    [5.04, 52.252],
    [5.043, 52.251],
    [5.046, 52.249],
    [5.049, 52.248],
    [5.051, 52.246],
    [5.053, 52.244],
    [5.058, 52.237],
    [5.042, 52.225],
    [5.034, 52.205],
    [5.04, 52.189],
    [5.045, 52.168],
  ],
  [
    [5.009, 52.277],
    [5.025, 52.282],
  ],
  [
    [4.933, 52.275],
    [4.942, 52.275],
  ],
  [
    [4.768, 52.221],
    [4.814, 52.23],
    [4.835, 52.236],
    [4.85, 52.246],
    [4.872, 52.252],
    [4.911, 52.256],
    [4.925, 52.272],
    [4.928, 52.274],
    [4.933, 52.275],
  ],
  [
    [5.127, 52.181],
    [5.182, 52.179],
  ],
  [
    [5.045, 52.168],
    [5.071, 52.171],
    [5.089, 52.177],
    [5.127, 52.181],
  ],
  [
    [5.366, 52.283],
    [5.368, 52.283],
  ],
  [
    [4.768, 52.221],
    [4.781, 52.207],
    [4.786, 52.203],
    [4.792, 52.199],
    [4.814, 52.194],
    [4.863, 52.168],
    [4.854, 52.163],
    [4.858, 52.152],
    [4.864, 52.141],
    [4.866, 52.138],
    [4.865, 52.136],
    [4.863, 52.134],
    [4.859, 52.133],
  ],
  [
    [4.859, 52.133],
    [4.843, 52.138],
    [4.838, 52.139],
    [4.834, 52.14],
    [4.831, 52.141],
  ],
  [
    [4.831, 52.141],
    [4.826, 52.14],
    [4.821, 52.14],
    [4.797, 52.124],
    [4.791, 52.12],
    [4.805, 52.112],
    [4.82, 52.109],
    [4.833, 52.072],
    [4.878, 52.071],
    [4.871, 52.065],
    [4.831, 52.053],
    [4.799, 52.023],
    [4.804, 52.016],
  ],
  [
    [4.85, 52.02],
    [4.854, 52.008],
    [4.841, 52.003],
    [4.834, 52.001],
    [4.828, 52.0],
    [4.824, 51.997],
    [4.833, 51.987],
    [4.865, 51.962],
    [4.887, 51.941],
  ],
  [
    [4.804, 52.016],
    [4.85, 52.02],
  ],
  [
    [5.105, 52.004],
    [5.119, 52.002],
    [5.131, 51.996],
    [5.145, 51.981],
    [5.154, 51.974],
    [5.173, 51.968],
    [5.183, 51.967],
  ],
  [
    [5.03, 51.974],
    [5.04, 51.977],
    [5.055, 51.989],
    [5.064, 51.993],
    [5.087, 51.997],
    [5.096, 52.001],
    [5.105, 52.004],
  ],
  [
    [4.989, 51.98],
    [5.03, 51.974],
  ],
  [
    [4.917, 51.947],
    [4.927, 51.949],
    [4.955, 51.967],
    [4.987, 51.979],
    [4.989, 51.98],
  ],
  [
    [4.894, 51.948],
    [4.917, 51.947],
  ],
  [
    [4.887, 51.941],
    [4.894, 51.948],
  ],
  [
    [4.935, 51.83],
    [4.986, 51.824],
  ],
  [
    [4.507, 51.695],
    [4.545, 51.696],
    [4.58, 51.702],
    [4.621, 51.715],
    [4.644, 51.719],
    [4.676, 51.719],
    [4.726, 51.757],
    [4.74, 51.774],
    [4.762, 51.789],
    [4.79, 51.803],
    [4.845, 51.803],
    [4.87, 51.808],
    [4.909, 51.83],
    [4.935, 51.83],
  ],
  [
    [4.986, 51.824],
    [5.009, 51.825],
  ],
  [
    [4.403, 51.708],
    [4.507, 51.695],
  ],
  [
    [4.198, 51.638],
    [4.239, 51.646],
    [4.28, 51.648],
    [4.334, 51.657],
    [4.373, 51.674],
    [4.403, 51.708],
  ],
  [
    [4.131, 51.658],
    [4.153, 51.653],
    [4.174, 51.643],
    [4.197, 51.638],
  ],
  [
    [4.111, 51.647],
    [4.114, 51.649],
    [4.131, 51.658],
  ],
  [
    [4.197, 51.638],
    [4.198, 51.638],
  ],
  [
    [5.188, 52.991],
    [5.26, 52.865],
    [5.37, 52.79],
  ],
  [
    [5.704, 52.838],
    [5.717, 52.836],
  ],
  [
    [5.372, 52.789],
    [5.558, 52.793],
    [5.6, 52.812],
    [5.632, 52.828],
    [5.657, 52.835],
    [5.681, 52.838],
    [5.704, 52.838],
  ],
  [
    [5.717, 52.836],
    [5.72, 52.837],
  ],
  [
    [5.37, 52.79],
    [5.372, 52.789],
  ],
  [
    [5.366, 52.283],
    [5.407, 52.268],
    [5.409, 52.268],
  ],
  [
    [5.426, 52.264],
    [5.497, 52.269],
    [5.533, 52.277],
    [5.552, 52.298],
    [5.563, 52.32],
    [5.579, 52.345],
    [5.601, 52.358],
    [5.628, 52.372],
    [5.655, 52.381],
    [5.689, 52.39],
    [5.733, 52.403],
    [5.771, 52.414],
    [5.796, 52.427],
    [5.815, 52.441],
    [5.838, 52.462],
    [5.855, 52.481],
    [5.866, 52.505],
    [5.867, 52.522],
  ],
  [
    [5.409, 52.268],
    [5.426, 52.264],
  ],
  [
    [5.867, 52.522],
    [5.847, 52.578],
    [5.833, 52.585],
    [5.833, 52.597],
    [5.843, 52.605],
    [5.844, 52.605],
  ],
  [
    [5.37, 52.79],
    [5.37, 52.789],
    [5.359, 52.689],
  ],
  [
    [5.359, 52.689],
    [5.309, 52.699],
  ],
  [
    [5.309, 52.699],
    [5.278, 52.686],
    [5.262, 52.649],
    [5.095, 52.582],
    [5.119, 52.516],
    [5.168, 52.472],
    [5.194, 52.429],
    [5.16, 52.429],
    [5.103, 52.396],
    [5.105, 52.364],
    [5.16, 52.328],
    [5.191, 52.323],
  ],
  [
    [5.249, 52.325],
    [5.283, 52.318],
    [5.368, 52.283],
  ],
  [
    [5.191, 52.323],
    [5.228, 52.325],
    [5.249, 52.325],
  ],
];

/** Grote rivieren (open polylijnen) — herkenbare waterlopen op het land. */
export const RIVERS: ReadonlyArray<GeoRing> = [
  [
    [5.858, 52.577],
    [5.877, 52.581],
    [5.91, 52.569],
    [5.947, 52.538],
    [5.974, 52.521],
    [6.017, 52.521],
    [6.031, 52.511],
    [6.043, 52.508],
    [6.05, 52.505],
    [6.056, 52.499],
    [6.064, 52.489],
    [6.082, 52.478],
    [6.089, 52.474],
    [6.095, 52.468],
    [6.104, 52.452],
    [6.112, 52.44],
    [6.133, 52.421],
    [6.135, 52.404],
    [6.124, 52.394],
    [6.12, 52.38],
    [6.105, 52.377],
    [6.087, 52.374],
    [6.082, 52.371],
    [6.087, 52.359],
    [6.078, 52.351],
    [6.069, 52.329],
    [6.068, 52.322],
    [6.071, 52.318],
    [6.081, 52.309],
    [6.086, 52.306],
    [6.107, 52.3],
    [6.112, 52.287],
    [6.125, 52.271],
    [6.124, 52.263],
    [6.124, 52.256],
    [6.128, 52.255],
    [6.139, 52.251],
    [6.144, 52.249],
    [6.146, 52.244],
    [6.142, 52.235],
    [6.146, 52.23],
    [6.16, 52.225],
    [6.167, 52.232],
    [6.177, 52.237],
    [6.189, 52.237],
    [6.186, 52.221],
    [6.186, 52.206],
    [6.192, 52.182],
    [6.194, 52.159],
    [6.192, 52.13],
    [6.206, 52.11],
    [6.208, 52.095],
    [6.194, 52.085],
    [6.171, 52.079],
    [6.122, 52.062],
    [6.116, 52.048],
    [6.122, 52.036],
    [6.14, 52.042],
    [6.155, 52.038],
    [6.159, 52.029],
    [6.147, 52.015],
    [6.122, 52.005],
    [6.095, 51.998],
    [6.076, 52.005],
    [6.054, 52.007],
    [6.029, 52.0],
    [6.002, 51.99],
    [5.994, 51.974],
    [5.965, 51.972],
    [5.955, 51.965],
    [5.939, 51.959],
  ],
  [
    [6.031, 51.88],
    [6.028, 51.89],
    [6.025, 51.896],
    [6.019, 51.901],
    [6.009, 51.906],
    [5.981, 51.916],
    [5.967, 51.925],
    [5.961, 51.936],
    [5.952, 51.95],
    [5.929, 51.965],
    [5.886, 51.987],
    [5.862, 51.973],
    [5.804, 51.973],
    [5.784, 51.96],
    [5.743, 51.969],
    [5.705, 51.963],
    [5.668, 51.952],
    [5.626, 51.947],
    [5.582, 51.953],
    [5.505, 51.982],
    [5.462, 51.987],
    [5.449, 51.985],
    [5.429, 51.977],
    [5.42, 51.974],
    [5.409, 51.974],
    [5.383, 51.98],
    [5.36, 51.977],
    [5.331, 51.963],
  ],
  [
    [5.331, 51.963],
    [5.31, 51.96],
    [5.254, 51.979],
    [5.239, 51.977],
    [5.221, 51.968],
    [5.197, 51.966],
    [5.173, 51.968],
    [5.154, 51.974],
    [5.145, 51.981],
    [5.131, 51.996],
    [5.118, 52.002],
    [5.105, 52.004],
    [5.095, 52.001],
    [5.087, 51.997],
    [5.064, 51.993],
    [5.055, 51.988],
    [5.04, 51.977],
    [5.03, 51.974],
    [4.989, 51.98],
    [4.987, 51.979],
    [4.955, 51.967],
    [4.927, 51.949],
    [4.917, 51.947],
    [4.851, 51.949],
    [4.831, 51.947],
    [4.776, 51.922],
    [4.74, 51.916],
    [4.681, 51.898],
    [4.595, 51.898],
    [4.572, 51.901],
    [4.528, 51.915],
    [4.509, 51.919],
    [4.461, 51.906],
    [4.341, 51.896],
    [4.309, 51.898],
    [4.277, 51.912],
    [4.238, 51.919],
    [4.128, 51.982],
    [4.098, 51.989],
  ],
  [
    [7.212, 50.6],
    [7.209, 50.609],
    [7.209, 50.634],
    [7.205, 50.651],
    [7.197, 50.67],
    [7.185, 50.687],
    [7.175, 50.699],
    [7.159, 50.71],
    [7.121, 50.729],
    [7.106, 50.74],
    [7.089, 50.764],
    [7.082, 50.767],
    [7.071, 50.769],
    [7.043, 50.78],
    [7.038, 50.785],
    [7.028, 50.806],
    [7.007, 50.82],
    [6.985, 50.831],
    [6.976, 50.84],
    [6.986, 50.855],
    [7.036, 50.875],
    [7.051, 50.891],
    [6.986, 50.902],
    [6.976, 50.908],
    [6.974, 50.918],
    [6.965, 50.934],
    [6.963, 50.943],
    [6.966, 50.953],
    [6.984, 50.962],
    [6.989, 50.973],
    [6.986, 50.98],
    [6.978, 50.986],
    [6.968, 50.99],
    [6.963, 50.994],
    [6.963, 51.004],
    [6.969, 51.024],
    [6.966, 51.028],
    [6.951, 51.033],
    [6.894, 51.069],
    [6.86, 51.073],
    [6.853, 51.076],
    [6.851, 51.087],
    [6.859, 51.093],
    [6.869, 51.097],
    [6.874, 51.1],
    [6.878, 51.114],
    [6.876, 51.121],
    [6.849, 51.128],
    [6.848, 51.137],
    [6.853, 51.151],
    [6.846, 51.16],
    [6.843, 51.161],
    [6.839, 51.159],
    [6.825, 51.158],
    [6.811, 51.151],
    [6.802, 51.151],
    [6.798, 51.161],
    [6.793, 51.184],
    [6.78, 51.185],
    [6.76, 51.181],
    [6.736, 51.186],
    [6.728, 51.196],
    [6.723, 51.212],
    [6.724, 51.227],
    [6.733, 51.233],
    [6.741, 51.231],
    [6.75, 51.228],
    [6.758, 51.226],
    [6.767, 51.23],
    [6.77, 51.238],
    [6.766, 51.243],
    [6.76, 51.247],
    [6.757, 51.251],
    [6.745, 51.256],
    [6.722, 51.262],
    [6.704, 51.271],
    [6.705, 51.286],
    [6.725, 51.303],
    [6.729, 51.311],
    [6.73, 51.326],
    [6.711, 51.337],
    [6.676, 51.348],
    [6.654, 51.36],
    [6.675, 51.377],
    [6.691, 51.38],
    [6.709, 51.381],
    [6.725, 51.383],
    [6.736, 51.391],
    [6.739, 51.407],
    [6.732, 51.42],
    [6.709, 51.44],
    [6.709, 51.446],
    [6.717, 51.453],
    [6.721, 51.463],
    [6.717, 51.47],
    [6.705, 51.474],
    [6.689, 51.475],
    [6.685, 51.48],
    [6.688, 51.487],
    [6.695, 51.494],
    [6.705, 51.5],
    [6.715, 51.503],
    [6.719, 51.507],
    [6.712, 51.518],
    [6.703, 51.526],
    [6.692, 51.531],
    [6.682, 51.538],
    [6.675, 51.549],
    [6.686, 51.565],
    [6.656, 51.572],
    [6.592, 51.577],
    [6.592, 51.583],
    [6.594, 51.594],
    [6.589, 51.613],
    [6.587, 51.63],
    [6.596, 51.637],
    [6.601, 51.641],
    [6.597, 51.648],
    [6.59, 51.655],
    [6.586, 51.659],
    [6.576, 51.661],
    [6.544, 51.659],
    [6.511, 51.664],
    [6.492, 51.669],
    [6.479, 51.675],
    [6.452, 51.704],
    [6.436, 51.714],
    [6.414, 51.72],
    [6.42, 51.741],
    [6.407, 51.754],
    [6.385, 51.76],
    [6.363, 51.762],
    [6.342, 51.766],
    [6.33, 51.776],
    [6.322, 51.789],
    [6.312, 51.803],
    [6.278, 51.821],
    [6.084, 51.854],
    [6.068, 51.861],
    [6.055, 51.87],
    [6.035, 51.879],
    [6.014, 51.885],
    [5.996, 51.885],
    [5.991, 51.88],
    [5.982, 51.863],
    [5.975, 51.857],
    [5.966, 51.857],
    [5.955, 51.86],
    [5.945, 51.864],
    [5.929, 51.877],
    [5.904, 51.87],
    [5.86, 51.851],
    [5.844, 51.853],
    [5.813, 51.867],
    [5.798, 51.87],
    [5.791, 51.87],
    [5.764, 51.887],
    [5.719, 51.894],
    [5.543, 51.901],
    [5.462, 51.892],
    [5.431, 51.875],
    [5.374, 51.818],
    [5.338, 51.81],
    [5.328, 51.814],
    [5.314, 51.826],
    [5.304, 51.83],
    [5.293, 51.83],
    [5.277, 51.825],
    [5.181, 51.816],
    [5.154, 51.818],
    [5.113, 51.828],
    [5.092, 51.83],
    [4.985, 51.824],
  ],
  [
    [4.985, 51.824],
    [4.935, 51.83],
    [4.909, 51.83],
    [4.87, 51.808],
    [4.845, 51.803],
    [4.79, 51.803],
    [4.761, 51.789],
    [4.74, 51.774],
    [4.726, 51.757],
    [4.676, 51.719],
  ],
  [
    [4.403, 51.708],
    [4.324, 51.729],
    [4.256, 51.757],
    [4.16, 51.801],
    [4.078, 51.844],
  ],
  [
    [7.91, 51.969],
    [7.857, 51.973],
    [7.808, 51.983],
    [7.771, 52.002],
    [7.77, 52.006],
    [7.772, 52.007],
    [7.775, 52.007],
    [7.778, 52.008],
    [7.769, 52.012],
    [7.76, 52.014],
    [7.74, 52.015],
    [7.731, 52.018],
    [7.727, 52.024],
    [7.726, 52.031],
    [7.723, 52.035],
    [7.714, 52.038],
    [7.709, 52.038],
    [7.703, 52.036],
    [7.692, 52.035],
    [7.683, 52.039],
    [7.669, 52.053],
    [7.658, 52.056],
    [7.656, 52.06],
    [7.651, 52.078],
    [7.648, 52.084],
    [7.64, 52.085],
    [7.618, 52.083],
    [7.613, 52.087],
    [7.591, 52.115],
    [7.588, 52.128],
    [7.613, 52.131],
    [7.608, 52.141],
    [7.61, 52.15],
    [7.619, 52.156],
    [7.634, 52.159],
    [7.634, 52.166],
    [7.579, 52.173],
    [7.552, 52.18],
    [7.537, 52.2],
    [7.542, 52.212],
    [7.537, 52.22],
    [7.525, 52.225],
    [7.511, 52.227],
    [7.511, 52.232],
    [7.512, 52.233],
    [7.514, 52.234],
    [7.518, 52.235],
    [7.509, 52.245],
    [7.499, 52.251],
    [7.484, 52.254],
    [7.466, 52.255],
    [7.46, 52.262],
    [7.443, 52.293],
    [7.436, 52.303],
    [7.359, 52.334],
    [7.353, 52.344],
    [7.344, 52.353],
    [7.341, 52.361],
    [7.344, 52.37],
    [7.353, 52.378],
    [7.35, 52.378],
    [7.339, 52.378],
    [7.339, 52.385],
    [7.346, 52.385],
    [7.346, 52.392],
    [7.326, 52.392],
    [7.333, 52.412],
    [7.333, 52.417],
    [7.331, 52.418],
    [7.328, 52.418],
    [7.326, 52.42],
    [7.33, 52.421],
    [7.339, 52.426],
    [7.339, 52.433],
    [7.331, 52.439],
    [7.312, 52.463],
    [7.296, 52.491],
    [7.293, 52.504],
    [7.298, 52.529],
    [7.287, 52.532],
    [7.277, 52.536],
    [7.272, 52.544],
    [7.277, 52.557],
    [7.273, 52.558],
    [7.264, 52.563],
    [7.277, 52.563],
    [7.277, 52.57],
    [7.266, 52.574],
    [7.257, 52.579],
    [7.253, 52.587],
    [7.257, 52.598],
    [7.253, 52.599],
    [7.243, 52.604],
    [7.253, 52.611],
    [7.258, 52.621],
    [7.257, 52.631],
    [7.25, 52.639],
    [7.25, 52.645],
    [7.257, 52.645],
    [7.257, 52.652],
    [7.25, 52.652],
    [7.25, 52.659],
    [7.263, 52.666],
    [7.278, 52.69],
    [7.292, 52.701],
    [7.271, 52.715],
    [7.263, 52.739],
    [7.26, 52.765],
    [7.25, 52.789],
    [7.26, 52.795],
    [7.263, 52.802],
    [7.258, 52.808],
    [7.243, 52.809],
    [7.251, 52.821],
    [7.279, 52.831],
    [7.285, 52.841],
    [7.291, 52.844],
    [7.304, 52.86],
    [7.313, 52.877],
    [7.309, 52.885],
    [7.302, 52.892],
    [7.297, 52.908],
    [7.292, 52.94],
    [7.295, 52.959],
    [7.311, 52.992],
    [7.312, 53.001],
    [7.318, 53.012],
    [7.319, 53.026],
    [7.317, 53.04],
    [7.312, 53.05],
    [7.307, 53.054],
    [7.291, 53.062],
    [7.288, 53.064],
    [7.283, 53.068],
    [7.285, 53.078],
    [7.292, 53.094],
    [7.307, 53.104],
    [7.362, 53.118],
    [7.36, 53.132],
    [7.36, 53.138],
    [7.365, 53.143],
    [7.366, 53.147],
    [7.367, 53.163],
    [7.368, 53.173],
    [7.373, 53.178],
    [7.38, 53.181],
    [7.387, 53.187],
    [7.394, 53.19],
    [7.4, 53.19],
    [7.406, 53.193],
    [7.408, 53.204],
    [7.41, 53.21],
    [7.416, 53.215],
    [7.424, 53.219],
    [7.429, 53.221],
    [7.429, 53.228],
    [7.405, 53.243],
    [7.397, 53.254],
    [7.393, 53.289],
    [7.388, 53.299],
    [7.378, 53.303],
    [7.367, 53.303],
  ],
  [
    [3.403, 50.6],
    [3.383, 50.617],
    [3.367, 50.637],
    [3.356, 50.658],
    [3.35, 50.684],
    [3.367, 50.717],
    [3.413, 50.747],
    [3.593, 50.832],
    [3.606, 50.842],
    [3.637, 50.878],
    [3.646, 50.884],
    [3.667, 50.893],
    [3.677, 50.9],
    [3.683, 50.911],
    [3.676, 50.917],
    [3.664, 50.923],
    [3.656, 50.933],
    [3.655, 50.947],
    [3.661, 50.951],
    [3.67, 50.952],
    [3.682, 50.956],
    [3.708, 50.974],
    [3.728, 50.994],
    [3.744, 51.017],
    [3.755, 51.046],
    [3.779, 51.043],
    [3.793, 51.034],
    [3.805, 51.022],
    [3.823, 51.009],
    [3.836, 51.003],
    [3.847, 51.003],
    [3.873, 51.009],
    [3.99, 51.015],
    [4.011, 51.013],
    [4.021, 51.014],
    [4.033, 51.018],
    [4.042, 51.026],
    [4.055, 51.045],
    [4.066, 51.052],
    [4.079, 51.054],
    [4.089, 51.051],
    [4.099, 51.046],
    [4.11, 51.043],
    [4.122, 51.045],
    [4.142, 51.057],
    [4.153, 51.06],
    [4.162, 51.055],
    [4.17, 51.046],
    [4.179, 51.041],
    [4.191, 51.045],
    [4.196, 51.055],
    [4.193, 51.066],
    [4.188, 51.077],
    [4.185, 51.087],
    [4.183, 51.096],
    [4.182, 51.1],
    [4.185, 51.104],
    [4.198, 51.114],
    [4.216, 51.122],
    [4.236, 51.124],
    [4.276, 51.124],
    [4.316, 51.132],
    [4.329, 51.148],
    [4.333, 51.17],
    [4.349, 51.197],
    [4.392, 51.225],
    [4.395, 51.234],
    [4.308, 51.269],
  ],
  [
    [5.691, 50.768],
    [5.698, 50.784],
    [5.704, 50.825],
    [5.7, 50.864],
    [5.681, 50.885],
    [5.688, 50.889],
    [5.701, 50.905],
    [5.705, 50.907],
    [5.717, 50.909],
    [5.722, 50.912],
    [5.735, 50.924],
    [5.752, 50.948],
    [5.763, 50.96],
    [5.754, 50.963],
    [5.744, 50.963],
    [5.722, 50.96],
    [5.761, 50.999],
    [5.777, 51.024],
    [5.763, 51.035],
    [5.766, 51.049],
    [5.771, 51.058],
    [5.779, 51.062],
    [5.791, 51.055],
    [5.798, 51.062],
    [5.804, 51.069],
    [5.811, 51.083],
    [5.809, 51.087],
    [5.807, 51.09],
    [5.804, 51.097],
    [5.815, 51.096],
    [5.826, 51.097],
    [5.836, 51.1],
    [5.845, 51.104],
    [5.823, 51.119],
    [5.826, 51.13],
    [5.86, 51.151],
    [5.875, 51.153],
    [5.884, 51.159],
    [5.891, 51.167],
    [5.899, 51.172],
    [5.917, 51.171],
    [5.933, 51.167],
    [5.946, 51.167],
    [5.955, 51.179],
    [5.946, 51.181],
    [5.942, 51.184],
    [5.939, 51.187],
    [5.934, 51.192],
    [5.954, 51.192],
    [5.969, 51.193],
    [5.979, 51.2],
    [5.983, 51.217],
    [5.99, 51.229],
    [6.005, 51.239],
    [6.016, 51.25],
    [6.009, 51.261],
    [6.009, 51.268],
    [6.031, 51.27],
    [6.065, 51.296],
    [6.101, 51.309],
    [6.113, 51.324],
    [6.123, 51.343],
    [6.133, 51.358],
    [6.143, 51.363],
    [6.153, 51.366],
    [6.162, 51.372],
    [6.167, 51.384],
    [6.166, 51.392],
    [6.156, 51.407],
    [6.153, 51.416],
    [6.157, 51.431],
    [6.174, 51.464],
    [6.181, 51.48],
    [6.18, 51.481],
    [6.18, 51.503],
    [6.181, 51.508],
    [6.172, 51.513],
    [6.146, 51.519],
    [6.14, 51.525],
    [6.133, 51.544],
    [6.114, 51.553],
    [6.071, 51.563],
    [6.059, 51.567],
    [6.053, 51.57],
    [6.049, 51.574],
    [6.043, 51.583],
    [6.031, 51.613],
    [6.027, 51.617],
    [6.026, 51.621],
    [6.006, 51.641],
    [5.997, 51.647],
    [5.987, 51.651],
    [5.982, 51.656],
    [5.989, 51.665],
    [5.973, 51.676],
    [5.96, 51.712],
    [5.944, 51.72],
    [5.904, 51.723],
    [5.888, 51.729],
    [5.879, 51.741],
    [5.882, 51.753],
    [5.863, 51.759],
    [5.76, 51.762],
    [5.69, 51.793],
    [5.671, 51.796],
    [5.661, 51.8],
    [5.649, 51.819],
    [5.643, 51.824],
    [5.598, 51.83],
    [5.534, 51.824],
    [5.52, 51.827],
    [5.501, 51.835],
    [5.481, 51.83],
    [5.462, 51.821],
    [5.441, 51.816],
    [5.401, 51.818],
    [5.381, 51.812],
    [5.372, 51.792],
    [5.367, 51.775],
    [5.354, 51.762],
    [5.337, 51.753],
    [5.318, 51.747],
    [5.119, 51.734],
    [5.089, 51.732],
    [5.071, 51.722],
    [5.061, 51.72],
    [4.903, 51.72],
    [4.879, 51.727],
    [4.866, 51.721],
    [4.841, 51.718],
    [4.827, 51.714],
  ],
  [
    [4.177, 51.686],
    [4.192, 51.68],
    [4.218, 51.664],
    [4.251, 51.654],
    [4.28, 51.648],
    [4.334, 51.657],
    [4.373, 51.674],
    [4.403, 51.708],
    [4.507, 51.695],
    [4.545, 51.696],
    [4.58, 51.703],
    [4.621, 51.715],
    [4.644, 51.719],
    [4.676, 51.719],
    [4.74, 51.725],
    [4.762, 51.725],
    [4.812, 51.713],
    [4.831, 51.712],
  ],
  [
    [5.477, 50.6],
    [5.49, 50.607],
    [5.499, 50.61],
    [5.561, 50.61],
    [5.571, 50.616],
    [5.579, 50.628],
    [5.584, 50.642],
    [5.592, 50.652],
    [5.599, 50.655],
    [5.618, 50.656],
    [5.626, 50.658],
    [5.635, 50.663],
    [5.639, 50.668],
    [5.642, 50.674],
    [5.646, 50.679],
    [5.666, 50.693],
    [5.688, 50.714],
    [5.7, 50.736],
    [5.688, 50.754],
    [5.688, 50.761],
    [5.691, 50.768],
  ],
  [
    [7.284, 51.986],
    [7.233, 51.991],
    [7.212, 51.99],
    [7.196, 51.982],
    [7.166, 51.956],
    [7.15, 51.947],
    [7.134, 51.946],
    [7.101, 51.953],
    [7.069, 51.951],
    [7.043, 51.952],
    [7.021, 51.955],
    [7.002, 51.969],
    [6.974, 51.985],
    [6.941, 51.999],
    [6.894, 52.013],
    [6.844, 52.034],
    [6.798, 52.058],
    [6.779, 52.075],
    [6.775, 52.086],
    [6.771, 52.109],
    [6.76, 52.114],
    [6.662, 52.127],
    [6.641, 52.123],
    [6.603, 52.132],
    [6.489, 52.18],
    [6.459, 52.184],
    [6.422, 52.178],
    [6.241, 52.171],
    [6.213, 52.173],
    [6.19, 52.182],
  ],
  [
    [7.91, 51.713],
    [7.887, 51.711],
    [7.76, 51.688],
    [7.618, 51.655],
    [7.593, 51.648],
    [7.566, 51.636],
    [7.535, 51.628],
    [7.501, 51.629],
    [7.472, 51.639],
    [7.452, 51.653],
    [7.44, 51.666],
    [7.428, 51.671],
    [7.381, 51.682],
    [7.357, 51.692],
    [7.337, 51.709],
    [7.317, 51.719],
    [7.291, 51.726],
    [7.244, 51.731],
    [7.219, 51.737],
    [7.195, 51.739],
    [7.172, 51.735],
    [7.056, 51.698],
    [7.027, 51.686],
    [6.996, 51.678],
    [6.947, 51.676],
    [6.903, 51.678],
    [6.867, 51.683],
    [6.835, 51.681],
    [6.799, 51.675],
    [6.773, 51.667],
    [6.739, 51.66],
    [6.684, 51.655],
    [6.634, 51.655],
    [6.608, 51.656],
    [6.59, 51.655],
  ],
  [
    [4.836, 50.642],
    [4.853, 50.661],
    [4.86, 50.678],
    [4.848, 50.71],
    [4.858, 50.727],
    [4.873, 50.742],
    [4.882, 50.765],
    [4.902, 50.787],
    [4.936, 50.808],
    [4.974, 50.822],
    [5.017, 50.833],
    [5.06, 50.849],
    [5.096, 50.87],
    [5.119, 50.893],
    [5.129, 50.915],
    [5.131, 50.933],
    [5.118, 50.951],
    [5.091, 50.974],
    [5.06, 50.992],
    [5.035, 51.0],
    [5.013, 51.002],
    [4.988, 51.009],
    [4.952, 51.012],
    [4.771, 50.985],
    [4.713, 50.982],
    [4.679, 50.988],
    [4.649, 50.997],
    [4.551, 51.014],
    [4.512, 51.027],
    [4.453, 51.051],
    [4.409, 51.082],
    [4.338, 51.103],
    [4.32, 51.114],
    [4.316, 51.132],
  ],
  [
    [7.347, 51.994],
    [7.385, 52.011],
    [7.407, 52.029],
    [7.408, 52.05],
    [7.376, 52.093],
    [7.357, 52.123],
    [7.34, 52.167],
    [7.328, 52.208],
    [7.326, 52.231],
    [7.322, 52.242],
    [7.294, 52.266],
    [7.272, 52.291],
    [7.24, 52.312],
    [7.228, 52.329],
    [7.21, 52.34],
    [7.192, 52.354],
    [7.182, 52.382],
    [7.12, 52.418],
    [6.998, 52.503],
    [6.965, 52.523],
    [6.955, 52.534],
    [6.949, 52.554],
    [6.937, 52.577],
    [6.913, 52.597],
    [6.879, 52.609],
    [6.845, 52.611],
    [6.817, 52.609],
    [6.781, 52.616],
    [6.729, 52.621],
    [6.708, 52.625],
    [6.686, 52.623],
    [6.654, 52.608],
    [6.627, 52.59],
    [6.607, 52.565],
    [6.584, 52.547],
    [6.555, 52.53],
    [6.533, 52.523],
    [6.517, 52.524],
    [6.486, 52.535],
    [6.446, 52.527],
    [6.413, 52.524],
    [6.325, 52.528],
    [6.255, 52.517],
    [6.227, 52.52],
    [6.203, 52.528],
    [6.178, 52.532],
    [6.15, 52.543],
    [6.119, 52.568],
    [6.094, 52.598],
    [6.081, 52.623],
    [6.071, 52.638],
    [6.053, 52.644],
    [6.029, 52.645],
    [6.01, 52.639],
    [5.988, 52.629],
    [5.963, 52.619],
    [5.941, 52.606],
    [5.92, 52.598],
    [5.878, 52.583],
  ],
  [
    [7.91, 51.496],
    [7.89, 51.502],
    [7.856, 51.497],
    [7.812, 51.486],
    [7.675, 51.479],
    [7.613, 51.458],
    [7.555, 51.431],
    [7.534, 51.425],
    [7.473, 51.421],
    [7.433, 51.407],
    [7.413, 51.405],
    [7.405, 51.397],
    [7.394, 51.393],
    [7.375, 51.399],
    [7.357, 51.412],
    [7.348, 51.424],
    [7.336, 51.433],
    [7.31, 51.438],
    [7.28, 51.437],
    [7.243, 51.424],
    [7.192, 51.424],
    [7.169, 51.417],
    [7.152, 51.415],
    [7.123, 51.431],
    [7.104, 51.429],
    [7.085, 51.418],
    [7.073, 51.408],
    [7.06, 51.403],
    [7.018, 51.406],
    [7.004, 51.401],
    [6.99, 51.39],
    [6.968, 51.38],
    [6.942, 51.375],
    [6.922, 51.379],
    [6.906, 51.391],
    [6.889, 51.407],
    [6.877, 51.423],
    [6.874, 51.434],
    [6.866, 51.443],
    [6.846, 51.454],
    [6.813, 51.46],
    [6.777, 51.459],
    [6.747, 51.455],
    [6.73, 51.456],
    [6.721, 51.463],
  ],
  [
    [4.574, 52.466],
    [4.592, 52.465],
    [4.617, 52.464],
    [4.64, 52.464],
    [4.659, 52.462],
    [4.675, 52.454],
    [4.7, 52.441],
    [4.72, 52.433],
    [4.742, 52.429],
    [4.778, 52.426],
    [4.815, 52.42],
    [4.844, 52.416],
    [4.867, 52.412],
    [4.885, 52.403],
    [4.896, 52.39],
    [4.902, 52.383],
    [4.913, 52.381],
    [4.95, 52.376],
    [4.971, 52.373],
  ],
  [
    [5.069, 52.344],
    [5.07, 52.337],
    [5.069, 52.33],
    [5.064, 52.32],
    [5.054, 52.315],
    [5.05, 52.308],
    [5.053, 52.302],
    [5.065, 52.296],
    [5.074, 52.292],
    [5.071, 52.284],
    [5.064, 52.282],
    [5.052, 52.281],
    [5.041, 52.277],
    [5.03, 52.272],
    [5.027, 52.265],
    [5.033, 52.256],
    [5.042, 52.254],
    [5.047, 52.246],
    [5.042, 52.24],
    [5.033, 52.235],
    [5.033, 52.216],
    [5.026, 52.208],
    [5.019, 52.199],
    [5.009, 52.195],
    [5.005, 52.19],
    [5.009, 52.182],
    [5.006, 52.174],
    [5.01, 52.166],
    [5.021, 52.156],
    [5.031, 52.153],
    [5.034, 52.146],
    [5.039, 52.141],
    [5.048, 52.135],
    [5.054, 52.129],
    [5.06, 52.131],
    [5.071, 52.129],
    [5.075, 52.122],
    [5.079, 52.119],
    [5.083, 52.118],
    [5.092, 52.118],
    [5.098, 52.114],
    [5.107, 52.108],
    [5.109, 52.104],
    [5.11, 52.097],
    [5.115, 52.089],
    [5.122, 52.083],
    [5.123, 52.078],
    [5.116, 52.065],
    [5.105, 52.047],
    [5.089, 52.029],
    [5.077, 52.015],
    [5.075, 52.01],
    [5.066, 52.006],
    [5.063, 51.999],
    [5.064, 51.993],
  ],
];
